import payoutsApi from 'services/api/payouts/payoutsApi';
import {
  PayoutErrorMessage,
  PayoutInfoMessage,
  PayoutAmount,
} from './components';
import { PayoutInfoLoader } from './styled';

interface PayoutInfoProps {
  onPayoutSuccess: () => void;
}

const PayoutInfo = ({ onPayoutSuccess }: PayoutInfoProps) => {
  const { data, isLoading, isError } = payoutsApi.useGetEarningsQuery();

  if (isLoading || !data) {
    return <PayoutInfoLoader variant="rectangular" />;
  }

  if (isError) {
    return <PayoutErrorMessage />;
  }

  if (!data.includesPaidRevenues && data.cents <= 0) {
    return <PayoutInfoMessage />;
  }

  return <PayoutAmount payout={data} onPayoutSuccess={onPayoutSuccess} />;
};

export default PayoutInfo;
